import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-3xl text-blue-700 font-light" }, "Võta ühendust!", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "block text-gray-500 text-sm font-normal text-left" }, "Kiri", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "font-roboto inline-flex items-center px-4 py-2.5 border border-transparent text-sm font-normal rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-0 focus:ring-blue-500 transition duration-300 ease-out"
  }, "Saada kiri")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_TextAreaField = _resolveComponent("TextAreaField")!

  return (_openBlock(), _createElementBlock("form", {
    class: "pt-8 space-y-4",
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendContact && _ctx.sendContact(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _createVNode(_component_InputField, {
      label: "Teema",
      "field-id": "contact-topic",
      "is-autocomplete": false,
      required: "",
      value: _ctx.topic,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.topic) = $event))
    }, null, 8, ["value"]),
    _createElementVNode("div", null, [
      _hoisted_2,
      _createVNode(_component_TextAreaField, {
        "field-id": "contact-content",
        "is-autocomplete": false,
        required: "",
        value: _ctx.content,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.content) = $event))
      }, null, 8, ["value"])
    ]),
    _hoisted_3
  ], 32))
}